<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const isVisible = ref(false);

const checkScroll = () => {
  isVisible.value = window.scrollY > 300;
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

onMounted(() => {
  window.addEventListener("scroll", checkScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", checkScroll);
});
</script>

<template>
  <button
    v-if="isVisible"
    class="scroll-to-top"
    aria-label="Прокрутить вверх"
    @click="scrollToTop"
  >
    <i class="raberu-icon-arrow-up"></i>
  </button>
</template>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--brand-color);
  color: var(--white-color);
  border: none;
  cursor: pointer;
  font-size: 20px;
  box-shadow: 0 2px 5px #0003;
  transition:
    opacity 0.3s,
    transform 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  &:hover {
    background: var(--brand-color);
    opacity: 88%;
    transform: scale(1.05);
  }
}
</style>
